import posthog from 'posthog-js'

/** Must match backend `analytics.constants.POSTHOG_DISTINCT_ID_HEADER`. */
export const POSTHOG_DISTINCT_ID_HEADER = 'X-PostHog-Distinct-Id' as const

/**
 * Returns PostHog's current distinct_id for the browser session, if available.
 *
 * Used to hand off anonymous frontend analytics to backend events before Clerk
 * sign-in creates a Fig user.
 */
export function getPostHogDistinctId(): string | undefined {
    try {
        const distinctId = posthog.get_distinct_id()?.trim()
        return distinctId || undefined
    } catch {
        return undefined
    }
}

/** Header map for Axios; empty when PostHog is unavailable or has no distinct_id yet. */
export function getPostHogDistinctIdHeaders(): Partial<Record<typeof POSTHOG_DISTINCT_ID_HEADER, string>> {
    const distinctId = getPostHogDistinctId()
    if (!distinctId) {
        return {}
    }

    return { [POSTHOG_DISTINCT_ID_HEADER]: distinctId }
}
